export default __webpack_public_path__ + "static/media/right-nav-arrow.386cd226.svg";